<template>
    <div class="topbar">
        <ul>
            <li>
                <img class="icona" src="../assets/telefono.png" alt="Icona telefono">
                <a href="tel:053525202">0535.25202</a>
            </li>
            <li  v-if="!isMobile">
                <img class="icona" src="../assets/MESSAGGI.png" alt="Icona mail">
                <p>info@tcan.it</p>
            </li>
            <li v-if="!isMobile">
                <img class="icona" src="../assets/FB.png" alt="Icona facebook">
                <p>Facebook</p>
            </li>
            <li v-if="!isMobile">
                <img class="icona" src="../assets/LINKEDIN.png" alt="Icona Linkedin">
                <p>LinkedIn</p>
            </li>
        </ul>
        <div class="indirizzo">
            <img class="icona" src="../assets/DOVE.png" alt="Icona posizione">
            <a href="https://maps.app.goo.gl/v1h2QGWLLaskRnRq6">Via 1° Gennaio 1948, 3/5 Mirandola</a>
        </div>
    </div>
</template>


<script>
    export default {
      name: 'TopBar',
      props: {
        msg: String
      },
      data() {
        return {
          windowWidth: window.innerWidth,
        };
      },
      computed: {
        isMobile() {
          return this.windowWidth <= 768; // breakpoint classico
        }
      },
      methods: {
        handleResize() {
          this.windowWidth = window.innerWidth;
        },
      },
      mounted() {
        window.addEventListener('resize', this.handleResize);
      },
      beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
      }
    }
</script>

<style lang="scss" scoped>

    .topbar {
        /*
        Questo codice serve a centrare gli elementi riseptto alla barra e tenere:
        a sinistra tutte le icone con i link ai social
        a destra l'indirizzo 
        */
        display: flex;
        justify-content: space-between;
        align-items: center;

        //Queste righe fanno in modo che la barra rimanga fissa in alto
        position: fixed;
        top: 0;

        background-color: black;
        color: white;  //Questo da il colore agli elementi interni della barra, in questo caso al testo
        height: 5vh;
        width: 100vw;
        font-size: 0.8rem;

        //Serve per non far andare sopra alla barra nessun elemento della pagina
        z-index: 9999;
        ul {
            display: flex;
            margin-left: 2vw;
            li {
                display: flex;
                align-items: center;
                justify-content: space-around;

                //Queste righe servono per far comparire la barra bianca al centro invece che attaccata a uno degli elementi
                margin-right: 2vw;
                padding-right: 2vw;

                border-right: 1px solid white; //La striscia laterale tra un elemento della barra e un altro
            }
        }
        a {
        //Questo serve per rendere il testo dei link uguale al resto dei testi, altrimenti stona
            text-decoration: none;
            color: inherit;
        }
    }

//Queste sono le icone della TopBar
.icona {
    margin-right: 0.5vw;
    height: 2.3vh;
}

//Questo è l'indirizzo a destra della barra
.indirizzo {
    //Questo codice serve a centrare il testo rispetto alla barra
    display: flex;
    align-items: center;

    margin-right: 2vw; //Per lasciare dello spazio a destra ed evitare che la scritta vada fuori schermo
}
</style>
